export const CONSTANT_URL = 'constants';

export const MEDIA_TYPES_URL = 'types/media';

export const DEVICE_TYPES_URL = 'types/device';
